import AppNavigation from './navigation/AppNavigation'

function App() {
  return <AppNavigation />
}

export default App
